import { FC } from 'react';
import { AdvancedFilterRow } from 'shared/components/AdvancedFilter/components/AdvancedFilterRow';
import { ByHomeownerContainer, PrepayContainer, WithCommissionContainer, WithDepositContainer } from './containers';
import { InlineFilterGroup } from 'shared/components/InlineFilterGroup';
import { useSelector } from 'react-redux';
import { selectRentTermsFilter } from 'shared/selectors/advancedFilters';
import { BX_COMISSION_FILTER_EXPERIMENT } from 'shared/constants/experiments';
import { useExperiment } from 'shared/hooks';

export const RentTermsContainer: FC = () => {
  const isRentCommissionFilterEnabled = useExperiment(BX_COMISSION_FILTER_EXPERIMENT);

  const { label } = useSelector(selectRentTermsFilter);

  return (
    <AdvancedFilterRow label={label}>
      <InlineFilterGroup>
        {isRentCommissionFilterEnabled ? (
          <>
            <ByHomeownerContainer />
            <WithDepositContainer />
            <PrepayContainer />
          </>
        ) : (
          <>
            <PrepayContainer />
            <WithDepositContainer />
            <WithCommissionContainer />
          </>
        )}
      </InlineFilterGroup>
    </AdvancedFilterRow>
  );
};
